export default function IntroPara() {
    return (
        <div className="my-4">
        <p className="text-xl">
        I am <span className="text-xl font-extrabold text-violet-500">
            Syed Javith
          </span>
          , I am excited to welcome you to my page.I describe me as an
          entusicatic , constant learner who has a view of changing life
          throw easy in technology
        </p>
        <p className="text-xl">
          Here In This page you can know me such as my education , skills
          and projects and ultimately a way to connect with me through
          social media accounts.
        </p>
        <a href="https://drive.google.com/uc?id=1r3_zt1age6UaK6UGYs3lJ5in9Pun91fP&export=download" download>
        <button className="bg-white p-2 rounded-lg text-violet-500 hover:opacity-85">
          Download My Resume
        </button>
        </a>
      </div>
    )
}